import { cloneDeep, isEqual } from 'lodash';
import { saveStates } from '@/constants/lifecycle';
import uuidGenerator from '@/utils/uuidGenerator';
import { hasKey } from '@/utils/resultsHelper';
import cohortProfile from '../../profile/state/state';
import addUUIDsToCohortFilters, { newCohortFilter, removeUUIDsFromCohortFilters } from '../../filters/state/state';

const activeClause = () => ({
  open: false,
  code: '',
  category: '',
  queryUUID: '',
  uuid: '',
  name: '',
  description: '',
  ...saveStates,
});

export const addUUIDsToCohortClause = (clause, addPlaceHolder = false, removeId = false) => {
  const copy = {
    ...clause,
    uuid: uuidGenerator.generate(),
    profile: cohortProfile(),
    filters: addUUIDsToCohortFilters(clause, addPlaceHolder, removeId),
  };

  if (removeId) {
    delete copy.id;
  }

  return (copy);
};

export const clauseNames = ({ clauses }) => clauses.filter((c) => !c.isNew).map((c) => c.name);

export const newCohortClause = (dictionary, name, description = '', isNew = true) => {
  const filters = [newCohortFilter()];

  return (
    {
      uuid: uuidGenerator.generate(),
      name,
      description,
      filters,
      dictionary: {
        code: dictionary.code,
        name: dictionary.name,
        description: dictionary.description,
      },
      profile: cohortProfile(),
      isNew,
    }
  );
};

const removeUUIDsFromCohortClause = (clause, removeId = false) => {
  const copy = {
    name: clause.name,
    description: clause.description,
    dictionary: { code: clause?.dictionary?.code },
    filters: removeUUIDsFromCohortFilters(clause.filters),
  };

  if (!removeId && clause.id) {
    copy.id = clause.id;
  }

  return copy;
};

export const removeUUIDsFromCohortClauses = (clauses, removeId = false, requiresFilters = true) => {
  const filteredClauses = clauses.filter((f) => !f.isNew).map((c) => removeUUIDsFromCohortClause(c, removeId));

  if (filteredClauses.length === 0 && !requiresFilters) {
    filteredClauses.push({
      ...removeUUIDsFromCohortClause(clauses[0], removeId),
      filters: [],
    });
  }

  return filteredClauses;
};

export const mergeClauses = (source, target, targetClauses, query) => query.clauses.map((clause, index) => {
  const sourceClause = source[index];
  const match = targetClauses.findIndex((y) => isEqual(y, sourceClause));
  const profile = (match >= 0 && hasKey(target[match], 'profile'))
    ? cloneDeep(target[match].profile) : clause.profile;

  return { ...clause, profile };
});

export default activeClause;
